import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'slick-carousel';
import 'jquery-scrollify';
// import Vivus from "vivus";


jQuery(document).ready(function($){

	// Menu
  $(".hamburger").click(function () {
    $(this).toggleClass("is-active");
    $("#menu").toggleClass("is-active");
    $("body").toggleClass("menu-open");
  });

  $("#menu nav ul > li > a[href*='#']").click(function () {
    if ($("body").hasClass("home")) {
    $('.hamburger').toggleClass("is-active");
    $("#menu").toggleClass("is-active");
    $("body").toggleClass("menu-open");
  
    // Update URL
    window.history.replaceState("", document.title, window.location.href.replace(location.hash, "") + this.hash);
    }
  });

	// Carousel
	$(".homepage-slider").slick({
    arrows: false,
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		fade: true,
  });

	// Scrollify
	// $.scrollify({
  //   section : ".home .content-area > div",
  //   sectionName : "",
  //   interstitialSection : ".non-full-height",
  //   easing: "easeOutExpo",
  //   scrollSpeed: 700,
  //   offset : 0,
  //   scrollbars: true,
  //   standardScrollElements: "",
  //   setHeights: true,
  //   overflowScroll: true,
  //   updateHash: false,
  //   touchScroll:false,
  //   before:function() {},
  //   after:function() {},
  //   afterResize:function() {},
  //   afterRender:function() {}
  // });

  // if($(window).width() < 767) {
  //   $.scrollify.disable()
  // }

  // Update scrollify contact section height on submit
  document.addEventListener( 'wpcf7submit', function( event ) {
    // $.scrollify.update();
  }, false );


	// Down Icon
	$(".down-icon").click(function() {
    $('html, body').animate({
      scrollTop: $("#next-section").offset().top
    }, 2000);
	});
})

jQuery(window).load(function($){

})

jQuery(window).resize(function($){

})

function sizetorow(divheight, target, adjustment){
	var $ = jQuery;
	if($(window).width() > 800){
		var maxHeight = 0;

		$(target).css('min-height',maxHeight);
		var maxHeight = $(divheight).height() - adjustment;
		console.log(maxHeight);
		//$(target).each(function(){
		//
		//})
		setTimeout(function(){
			$(target).css('min-height',maxHeight);
		},600)
	}
}

function makesquare(target){
	var $ = jQuery;
	var width = $(target).width();
	$(target).height(width);
}

// When the user scrolls the page, execute myFunction
window.onscroll = function() {myFunction()};

// Get the header
var header = document.getElementById("header");

// Get the offset position of the navbar
var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}


// WEBPACK FOOTER //
// ./main.js